import InputFormComponent from "components/UI/InputFormComponent/InputFormComponent";
import React, { useEffect } from "react";
import "./InputForm.scss";

const InputForm = ({
	inputField,
	setInputField,
	setValidate,
	inputType,
	placeholder,
	inputName,
	setError,
	classNameInput
}) => {
	useEffect(() => {
		if (inputField === "" || inputField.length === 0) {
			setValidate(false);
			// setError('Los campos son obligatorios')
		} else {
			setValidate(true);
			setError('')
		}
	}, []);

	const handleChangeInput = (event) => {
		event.preventDefault();
		let value = event.target.value;
		setInputField(value);
		if (event.target.value === "") {
			setValidate(false);
			setError('Los campos son obligatorios');
		} else {
			if (inputType === "number") {
				if (isNaN(value)) {
					setValidate(false);
					setError('Ingrese solo números');
				} else {
					setValidate(true);
					setError('');
				}
			} else {
				setValidate(true);
			}
		}
	};

	return (

		<InputFormComponent
			className={`form__input ${classNameInput}`}
			type="text"
			placeholder={placeholder}
			name={inputName}
			value={inputField}
			autoFocus
			onChange={handleChangeInput}
		/>
	);
};

export default InputForm;
